import { createShorthandFactory } from '@flowio/react-helpers';
import { defaultIntent } from './constants';
import Feedback from './components/Feedback';
var createFeedback = createShorthandFactory(Feedback, function (value) {
  return {
    children: value,
    intent: defaultIntent
  };
});
export default createFeedback;